(() => {
  document.documentElement.classList.add('yb-site-polish');
  if (document.querySelector('.yb-hero')) {
    document.body.classList.add('yb-home-polish');
  }

  const header = document.querySelector('.header-wrapper');
  const onScroll = () => {
    if (header) header.classList.toggle('yb-header-scrolled', window.scrollY > 12);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = document.querySelectorAll('.yb-fade-up');
  if (!reduced && revealItems.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18 }
    );
    revealItems.forEach((item, index) => {
      item.style.transitionDelay = `${Math.min(index % 6, 5) * 70}ms`;
      observer.observe(item);
    });
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-yb-dismiss]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = button.closest('[data-yb-dismissible]');
      if (target) target.hidden = true;
    });
  });

  document.querySelectorAll('[data-yb-tabs]').forEach((tabs) => {
    tabs.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-yb-tab]');
      if (!tab) return;
      const value = tab.dataset.ybTab;
      tabs.querySelectorAll('[data-yb-tab]').forEach((item) => item.classList.toggle('is-active', item === tab));
      const scope = tabs.closest('.yb-featured-products');
      if (!scope) return;
      scope.querySelectorAll('[data-yb-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.ybPanel !== value;
      });
    });
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest(
      '[data-yeahbox-variant-media-id], [data-yeahbox-ultra-k-color-target]'
    );
    if (!input || !input.checked) return;

    const mediaId = input.dataset.yeahboxUltraKColorTarget || input.dataset.yeahboxVariantMediaId;
    if (!mediaId) return;

    const productInfo = input.closest('product-info');
    const gallery = productInfo?.querySelector('media-gallery');
    if (gallery?.setActiveMedia) {
      gallery.setActiveMedia(mediaId, false);
    }

    const yeahboxMedia = productInfo?.querySelector('[data-yeahbox-product-media]');
    if (yeahboxMedia) {
      yeahboxMedia.dispatchEvent(
        new CustomEvent('yeahbox:select-media', {
          detail: { mediaId },
        })
      );
    }
  });
})();
